module.exports = __webpack_public_path__ + "img/进销存管理.93ac3b20.svg";